import { useEffect, useState } from 'react';

/**
 * Presence machine for overlays that animate on exit: while `visible` is true the
 * overlay is present immediately; when `visible` flips false, presence is held for
 * `exitMs` so the collapse/close animation can play before the overlay unmounts.
 *
 * Splits "mounted" (this hook's return) from "open" (`visible`): a closed-idle
 * overlay stops existing (no global listeners, no data fetch), while a closing one
 * stays mounted exactly through its exit animation.
 */
export function useOverlayPresence({
  visible,
  exitMs,
}: {
  visible: boolean;
  exitMs: number;
}): boolean {
  const [present, setPresent] = useState(visible);

  useEffect(() => {
    if (visible) {
      setPresent(true);
      return;
    }
    const exitTimer = window.setTimeout(() => setPresent(false), exitMs);
    return () => window.clearTimeout(exitTimer);
  }, [visible, exitMs]);

  return present;
}
